import { render } from "./PropertyDeletePanel.vue?vue&type=template&id=89c61e5e"
import script from "./PropertyDeletePanel.vue?vue&type=script&lang=ts"
export * from "./PropertyDeletePanel.vue?vue&type=script&lang=ts"
script.render = render

export default script